import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EbayService {
  
  baseUrl = environment.baseUrl;


  constructor(private http:HttpClient,
    private datePipe: DatePipe,) { }
  
  get_ebay_orders() {
    return this.http.get(this.baseUrl + '/ebay/get_orders');  
  }

  get_ebay_order_status() {
    return this.http.get(this.baseUrl + '/ebay/get_ebay_order_status');  
  }

  get_order_by_id(id) {
    return this.http.get(this.baseUrl + '/ebay/get_order_by_id/' + id);  
  }

  update_ebay_status(order_id, FormData) {
    console.log(this.baseUrl + '/ebay/update_ebay_status/' + order_id);
    return this.http.post(this.baseUrl + '/ebay/update_ebay_status/' + order_id,{
      new_status_id: FormData.order_status_id
    });  
  }

  update_ebay_orders_status(selectedOrders, new_status_id) {
    let postData = {
      orders: selectedOrders,
      new_status_id: new_status_id
    };
    return this.http.post(this.baseUrl + '/ebay/update_ebay_orders_status', postData);  
  }

  ebay_get_questionnaire(order_item_id) {
    return this.http.get(this.baseUrl + '/ebay/ebay_get_questionnaire/' + order_item_id);  
  }

}
